import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ILeadValidationFieldResult {
  Code?: string;
  Message?: string;
  RiskLevel?: 'High' | 'Medium' | 'Low' | string;
}

export interface ILeadValidationResponse {
  ValidationId?: number;
  Result?: string;
  Reasons?: {
    Email?: ILeadValidationFieldResult;
    Phone?: ILeadValidationFieldResult;
  };
}


@Injectable({
  providedIn: 'root'
})
export class LeadFormService {

  constructor(
    private http: HttpClient
  ) { }

  private getBaseApiUrl(): string {
    return isDevMode() ? 'http://localhost:4000/' : '/';
  }

  submitHLLead(params: any, subPage: string) {
    debugger;
    const url = isDevMode() ?`http://localhost:4000/${subPage}/api/SubmitLead` :  `/${subPage}/api/SubmitLead`;
    return this.http.post(url, params)
  }

  validateLead(payload: {
    firstName: string;
    lastName: string;
    hyperionId: string;
    email: string;
    phone: string;
  }): Observable<ILeadValidationResponse | null> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const url = `${this.getBaseApiUrl()}v2/api/sitecore/leadValidation/validateLead`;

    return this.http.post<ILeadValidationResponse>(url, payload, { headers }).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }
}
